import {createModel} from '@rematch/core';
import {RootModel} from './index';
import {IRoom} from '../../Constants/Interfaces';

import {db} from '../../Firebase/main';


interface chats {
    rooms: { [id: string]: IRoom };
    defaultRoomId: string;
}


const init: chats = {
    rooms: {['metaverse']: {id: 'metaverse', title: 'Metaverse', timestamp: 0}},
    defaultRoomId: 'metaverse',
};

export const Chats = createModel<RootModel>()({
    state: init,
    reducers: {
        updateRooms(state, payload: Partial<chats>) {
            return {...state, ...payload};
        },
    },
    effects: (dispatch) => ({
        async getRooms(): Promise<void> {

            await db
                .ref('chats')
                .get()
                .then((snap) => {
                    if (snap.exists()) {

                        const rooms = snap.val() as typeof init.rooms;

                        const defaultRoomId = Object
                            .values(rooms)
                            .find((room) => room.link && window.location.href.includes(room.link))
                            ?.id || 'metaverse';


                        dispatch.chats.updateRooms({rooms, defaultRoomId});
                        dispatch.messages.handleRoomSelect(defaultRoomId);
                    }
                })
                .catch(console.error);
        },
    }),
});
